import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from '../redux/store';

PedidoIdGuard.propTypes = {
  children: PropTypes.node
};

export default function PedidoIdGuard({ children }) {
  const pedidoId = useSelector((state) => state.pedidos.pedidoIdAtual);

  if (!pedidoId) {
    return <Navigate to='/' />;
  }

  return <>{children}</>;
}
